import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { PISparePartModel } from '../../models/pi-spare-part.model';
import { PISparePartArrayModel } from '../../models/pi-spare-part-array.model';

@Component({
    selector: 'pace-pi-spare-part',
    templateUrl: './pi-spare-part.component.html',
    standalone: false,
})
export class PISparePartComponent implements OnInit {
    @Input()
    public model: PISparePartArrayModel;
    @Input()
    public parentForm: FormArray;

    public formChildren: FormArray;
    public pISparePartForm: FormGroup;

    public constructor(private readonly formBuilder: FormBuilder) {}

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.pISparePartForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
        this.parentForm.push(this.pISparePartForm);
    }

    public addMaterial(): void {
        this.model.materials.addModel(new PISparePartModel());
    }

    public deleteMaterial(index: number): void {
        this.model.materials.removeModel(index);
    }

    /**
     * This function splits materials for material with batch number.
     * if the quantity is greater than 1, split the material into multiple rows with quantity 1
     * Example: quantity = 3 -> 3 rows with quantity 1
     * For materials without batch number, it will validate the comment field.
     * i.e if quantity is 0, then make comment mandatory
     *
     * @param index index of material in the array
     * @param control form control class of the quantity field
     */
    public validateRowWithIndex(index: number, control: AbstractControl): void {
        const rowToValidate = this.model.materials.getModelByIndex(index);
        if (rowToValidate.isBatchNumberRequired) {
            this.model.splitMaterial(index);
        } else {
            rowToValidate.validateFields();
        }
        control.updateValueAndValidity();
    }
}
